import React, {CSSProperties, HTMLAttributes} from 'react'

import {surfaceColors, surfaceSizes} from './styles.js'

/** A full-width grey line between parts of a page or a list. It has no margins: give the space in the style. */
export default function Divider({style, ...rest}: HTMLAttributes<HTMLDivElement>) {
    const dividerStyle: CSSProperties = {
        width: '100%',
        height: surfaceSizes.dividerHeight,
        background: surfaceColors.divider,
        ...style
    }

    return <div role='separator' {...rest} style={dividerStyle} />
}
